/**
 * 账户相关页面的路由
 */
const accountRouter = [
  {
    path: '/login',
    component: () => import('@/views/loginactivate'),
    name: 'Login',
    meta: { title: '登录', auth: false },
  },
];

export default accountRouter;
